import { NgModule } from '@angular/core';
import { LoginGuard } from '../login/login.guard';
import { Rol } from 'modelos/src';
import { Route, RouterModule } from '@angular/router';
import { NavigationComponent } from './navigation/navigation.component';
import { AlarmasModule } from '../entidades/alarmas/module';
import { ColectivosModule } from '../entidades/colectivos/module';
import { ActivosModule } from '../entidades/activos/module';
import { AdministracionModule } from '../entidades/administracion/module';
import { MapaModule } from '../entidades/mapa/mapa.module';
import { ConfiguracionModule } from '../entidades/configuracion/module';
import { VehiculosModule } from '../entidades/vehiculos/module';
import { LuminariasModule } from '../entidades/luminarias/module';
import { EmergenciasModule } from '../entidades/emergencias/module';
import { BotonDePanicoModule } from '../entidades/integraciones/boton-de-panico/boton-de-panico.module';
import { AlertasSeguridadModule } from '../entidades/alertas-seguridad/alertas-seguridad.module';
import { VecinosSeguridadModule } from '../entidades/vecinos-seguridad/vecinos-seguridad.module';

import { ListadoEventosPersonalizadosGrupoComponent } from '../standalone/grupos/listado-eventos-personalizados-grupo/listado-eventos-personalizados-grupo.component';
import { LogsModule } from '../entidades/logs/module';
import { SirenasModule } from '../entidades/sirenas/module';
import { EventosGenericosModule } from '../entidades/eventos-genericos/module';
import { DashboardGeneralModule } from '../entidades/dashboard-general/module';
import { GastosModule } from '../entidades/gastos/module';
import { FacturacionModule } from '../entidades/facturacion/module';
import { CamarasModule } from '../entidades/camaras/module';
import { ServicioTecnicoModule } from '../entidades/servicio-tecnico/module';
import { AyudaModule } from '../entidades/ayuda/module';
import { ChangelogModule } from '../entidades/changelog/module';

type MyRoutes = Route & { children?: MyRoutes[]; data?: { roles?: Rol[] } };

const routes: MyRoutes[] = [
  {
    path: '',
    component: NavigationComponent,
    canActivate: [LoginGuard],
    canActivateChild: [LoginGuard],
    children: [
      { path: '', redirectTo: 'mapa', pathMatch: 'full' },
      // eventos genericos
      {
        path: 'eventos-genericos',
        loadChildren: () => EventosGenericosModule,
      },
      {
        path: 'gastos',
        loadChildren: () => GastosModule,
      },
      // Facturación (solo nivel 0, ver FacturacionGuard)
      {
        path: 'facturacion',
        loadChildren: () => FacturacionModule,
      },
      // Facturación nueva (convive con la anterior hasta reemplazarla)
      {
        path: 'facturacion-v2',
        loadChildren: () =>
          import('../entidades/facturacion-v2/facturacion.routes').then(
            (m) => m.FACTURACION_V2_ROUTES,
          ),
      },
      {
        path: 'mapa',
        loadChildren: () => MapaModule,
      },
      // Activos
      {
        path: 'activos',
        loadChildren: () => ActivosModule,
      },
      // Vehiculos
      {
        path: 'vehiculos',
        loadChildren: () => VehiculosModule,
      },
      //Alarmas
      {
        path: 'alarmas',
        loadChildren: () => AlarmasModule,
      },
      //Camaras
      {
        path: 'camaras',
        loadChildren: () => CamarasModule,
      },
      //Luminarias
      {
        path: 'luminarias',
        loadChildren: () => LuminariasModule,
      },
      //Sirenas
      {
        path: 'sirenas',
        loadChildren: () => SirenasModule,
      },
      {
        path: 'eventos-genericos',
        loadChildren: () => EventosGenericosModule,
      },
      {
        path: 'dashboard-general',
        loadChildren: () => DashboardGeneralModule,
      },
      //Emergencias Médicas
      {
        path: 'emergencias',
        loadChildren: () => EmergenciasModule,
      },
      //Colectivos
      {
        path: 'colectivos',
        loadChildren: () => ColectivosModule,
      },
      // configuracion
      {
        path: 'configuracion',
        loadChildren: () => ConfiguracionModule,
      },
      //Administracion
      {
        path: 'administracion',
        loadChildren: () => AdministracionModule,
      },
      //Integraciones
      {
        path: 'botondepanico',
        loadChildren: () => BotonDePanicoModule,
      },
      // Alertas de Seguridad
      {
        path: 'alertas-seguridad',
        loadChildren: () => AlertasSeguridadModule,
      },
      // Vecinos de Seguridad
      {
        path: 'vecinos-seguridad',
        loadChildren: () => VecinosSeguridadModule,
      },
      //Logs
      {
        path: 'logs',
        loadChildren: () => LogsModule,
      },
      // Servicio Técnico
      {
        path: 'servicio-tecnico',
        loadChildren: () => ServicioTecnicoModule,
      },
      // Ayuda
      {
        path: 'ayuda',
        loadChildren: () => AyudaModule,
      },
      // Changelog
      {
        path: 'changelog',
        loadChildren: () => ChangelogModule,
      },

      //Eventos Personalizados
      {
        path: 'eventosPersonalizados/:categoria/:id',
        title: 'Eventos personalizados',
        component: ListadoEventosPersonalizadosGrupoComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NavigationRoutingModule {}
